import React, { useState } from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
//Translations
import { useTranslation, Trans } from 'react-i18next';
// core components
import GridContainer from "components/grid/gridContainer.js";
import GridItem from "components/grid/gridItem.js";
import Card from "components/card/Card.js";

import image1 from "assets/images/getStarted/Image_Microsite_Announcement_1.png";
import image2 from "assets/images/getStarted/Image_Microsite_Announcement_2.png";
import image3 from "assets/images/getStarted/Image_Microsite_Announcement_3.png";

import carouselStyle from "assets/jss/views/components/carouselStyle.js";


// ! test comment red
// ? 
// TODO
// * other
// Normal comment
function CarouselSection() {
  const classes = carouselStyle();

  useTranslation();

  const settings = {
    dots: true,
    infinite: true,
    speed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
  };


  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8} className={classes.carouselGrid}>
            <Card carousel>
              <Carousel {...settings}>
                <div>
                  <img src={image1} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <strong><Trans i18nKey="getStartedAvailabilityTitle" /></strong>
                    </h4>
                    <p>
                      <Trans i18nKey="getStartedAvailabilityMessage" />
                    </p>
                  </div>
                </div>
                <div>
                  <img
                    src={image2}
                    alt="Second slide"
                    className="slick-image"
                  />
                  <div className="slick-caption">
                    <h4>
                      <Trans i18nKey="getStartedOnDemandTitle" />
                    </h4>
                    <p>
                      <Trans i18nKey="getStartedOnDemandMessage" />
                    </p>
                  </div>
                </div>
                <div>
                  <img src={image3} alt="Third slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <Trans i18nKey="getStartedCardioConsolesTitle" />
                    </h4>
                    <p>
                      <Trans i18nKey="getStartedCardioConsolesMessage" />
                    </p>
                  </div>
                </div>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}


export default CarouselSection;